import { render, staticRenderFns } from "./Passage.vue?vue&type=template&id=18515008&scoped=true&"
import script from "./Passage.vue?vue&type=script&lang=ts&"
export * from "./Passage.vue?vue&type=script&lang=ts&"
import style0 from "./Passage.vue?vue&type=style&index=0&id=18515008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18515008",
  null
  
)

export default component.exports